
import { css } from 'lit';
export default css`
:host {
  width: auto;
}

.hidden {
  display: none;
}

.select__wrapper {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(216, 216, 216, var(--tw-border-opacity));
  font-size: 1.25rem;
}

.select__button {
  cursor: pointer;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1.25rem;
  padding-right: 3rem;
  background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 18 10" xmlns="http://www.w3.org/2000/svg"><path xmlns="http://www.w3.org/2000/svg" d="M17.7801 0.344924C17.4869 0.051692 17.0129 0.051692 16.7196 0.344924L9 8.06451L1.28042 0.344924C0.987188 0.051692 0.513186 0.051692 0.219954 0.344924C-0.0732775 0.638156 -0.0732775 1.11216 0.219954 1.40539L8.46979 9.65522C8.61604 9.80147 8.80802 9.87498 9.00004 9.87498C9.19206 9.87498 9.38404 9.80147 9.53029 9.65522L17.7801 1.40539C18.0733 1.11216 18.0733 0.638156 17.7801 0.344924Z" fill="%23434B5A"/></svg>');
  background-repeat: no-repeat;
  background-position: right 1.25rem center;
  background-size: 18px;
}
`;